export default {
  patientsPayments: [],
  patientsPaymentsCount: 0,
  materialsWriteOff: [],
  cash_register_total: null,
  totalByDirection: null,
  total_by_snapshot: null,
  total_by_selling: null,
  total_by_prepayment: null,
  total_by_discount: null,
  debtors: [],
  advances: [],
  insurancesPerPage: [],
  insurancesPerPageTotalCount: 0,
  certificates: [],
  certificatesPerPage: [],
  certificatesPerPageTotalCount: 0,
  cashlessPayments: [],
  cashRegisterSections: [
    { label: 'Итого по направлениям', section: 'direction' },
    { label: 'Итого по продажам', section: 'selling' },
    { label: 'Итого по скидкам', section: 'discount' },
    { label: 'Итого по снимкам', section: 'snapshot' },
  ],
  goToPaymentInfo: null,
}
